import { useTranslation } from "react-i18next";
import FooterBrand from "./FooterBrand";
import FooterColumn from "./FooterColumn";
import { FOOTER_COLUMNS } from "./footerLinks";

export default function Footer() {
  const { t } = useTranslation("landing");

  return (
    <footer className="relative mt-16 overflow-hidden border-t border-line bg-canvas-2 pt-16 sm:mt-20 lg:mt-24">
      {/* نوار گرادیان بالای فوتر */}
      <div
        aria-hidden
        className="absolute inset-x-0 top-0 h-[2px] bg-gradient-to-r from-transparent via-teal-2 to-transparent"
      />

      <div className="mx-auto max-w-container px-5 sm:px-7">
        {/* Grid */}
        <div className="grid grid-cols-1 gap-10 pb-12 sm:!grid-cols-2 sm:!gap-12 lg:!grid-cols-[1.7fr_1fr_1fr_1fr] lg:!gap-14">
          <FooterBrand />
          {FOOTER_COLUMNS.map((column) => (
            <FooterColumn key={column.key} column={column} />
          ))}
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col items-center gap-3 border-t border-line py-7 sm:flex-row sm:justify-between">
          <p className="text-center text-[13px] text-ink-soft sm:text-start sm:text-[13.5px]">
            {t("footer.copyright")}
          </p>

          <div className="flex items-center gap-5 text-[13px] text-ink-soft">
            <a
              href="#"
              className="transition-colors hover:text-teal-2 dark:hover:text-teal-3"
            >
              {t("footer.privacy")}
            </a>
            <span className="h-3 w-px bg-line" aria-hidden />
            <a
              href="#"
              className="transition-colors hover:text-teal-2 dark:hover:text-teal-3"
            >
              {t("footer.terms")}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}